<template>
  <div dir="ltr">
    <div id="fullpage" onclick="this.style.display='none';"></div>
    <div class="fixed-bottom text-left ml-3 mb-5 widget-icon" v-if="!messengerShow">
      <i class="fad fa-comments-alt messenger" id="messengerShow" @click="Showmessenger()"></i>
      <span class="position-absolute start-100 translate-middle badge rounded-pill" style="background-color: red;right: 40% !important;" v-if="totalUnseenMessage > 0">
        {{ totalUnseenMessage }}
      </span>
      <!-- <i class="ml-4 mt-2 overlay-messenger h1" style="color: red" v-if="totalUnseenMessage > 0">{{ totalUnseenMessage }}</i> -->
    </div>

    <!-- col-lg-5 col-md-5 col-11 col-xl-4 col-sm-5 -->
    <div class="col-6 col-md-5 col-lg-5 col-xl-3 fixed-bottom mb-0 fadeInUp" v-if="messengerShow" id="main">
      <div class="card text-center" dir="rtl" v-if="!groupInfoPage">
        <!-- هدر -->
        <div v-if="!isChatRoomsList & !createGroupPage" class="card-header">
          <div clss="row text-right">
            <span class="float-right row">
              <div class="imgBox">
                <img src="@/assets/icons/user-circle-solid.svg" class="float-right imgChatRoom bg-primary" v-if="(profileChatRoom == null) & !isGroup" />

                <div @click="getGroupInfo()" style="cursor: pointer">
                  <img src="@/assets/icons/group-svgrepo-com.svg" class="float-right imgChatRoom bg-primary" v-if="(profileChatRoom == null) & isGroup" />
                  <img :src="url + profileChatRoom" class="float-right imgChatRoom bg-primary" v-if="profileChatRoom != null" />
                </div>
              </div>
              <span class="mr-3 mt-3 h5">
                {{ ChatRoomName }}
                <i class="fa-light fa-hand-wave" @click="shake()" v-if="!isGroup"></i>
              </span>
            </span>
            <i class="fad fa-address-book float-left mt-3 h4" @click="getChatRooms()" title="لیست مخاطبین"></i>
            <!-- <i class="fas fa-window-minimize hover-info float-left mt-2 ml-2 h5"></i> -->
            <i class="fad fa-times-square float-left mt-3 ml-3 h4" @click="messengerShow = false"></i>
          </div>
        </div>
        <div v-else class="card-header">
          <div clss="text-right">
            <div class="row">
              <div class="col-8">
                <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserId" :rownumintable="3" v-if="!createGroupPage" :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserIdMessenger'" :keyItem="'UserIdMessenger'"> </SearchableCombo>
              </div>
              <div class="col-4 mt-2">
                <i class="fad fa-times-square float-left h4" @click="messengerShow = false"></i>
                <!-- <i class="fas fa-users-medical float-left h4 ml-3" @click="createGroup()" v-if="isChatRoomsList"></i> -->
                <i
                  class="fad fa-arrow-left float-left text-primary h4 ml-3"
                  @click="
                    createGroupPage = false;
                    isChatRoomsList = true;
                  "
                  v-if="createGroupPage"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <!-- پایان هد -->

        <!-- صفحه پیام ها -->
        <div v-if="!isChatRoomsList & !createGroupPage" class="card-body bg-light col overflow-auto chatBox d-flex flex-column-reverse">
          <!-- نمایش فایل ارسالی -->
          <div class="row p-2 imageName mr-1" v-if="uploadFileName != ''">
            <div class="col-12 text-right m-0 text-secondary font-weight-bold">
              {{ uploadFileName }} - {{ fileSize }} &nbsp;&nbsp;&nbsp;
              <i class="fad fa-upload text-secondary"></i>
              <i @click="cancelUpload()" class="fas fa-times float-left"></i>
            </div>
          </div>
          <!-- پایان نمایش فایل ارسالی -->

          <div v-for="item in chatMessage" :key="item.Id">
            <!-- پیام های من -->
            <div v-if="item.SenderTblUserId == userId" class="message my_msg justify-content-start">
              <p class="text-right cusrser-default" v-if="item.TblComboGrpId43 == 1802" @dblclick="showDropDown(item.Id)" style="word-wrap: break-word; white-space: pre-wrap">
                {{ item.DecryptMessage }}

                <b-dropdown size="md" variant="link" text="" toggle-class="text-decoration-none d-inline float-left text-left position-relative d-none btn-drop" style="cursor: default !important" no-caret>
                  <template #button-content>
                    <i class="fal fa-info-circle hover-warning text-secondary float-left d-none cusrser-default" style="cursor: default !important" :id="'drop-' + item.Id" />
                  </template>
                  <b-dropdown-item toggle-class="text-right" @click="edit(item)"> ویرایش </b-dropdown-item>
                  <b-dropdown-item toggle-class="text-right" @click="remove(item)"> حذف </b-dropdown-item>
                </b-dropdown>

                <br />
                <span class="text-dark d-inline">{{ item.DateTimeInsert }}</span>
                <i class="fas fa-check-double text-se fs-2" v-if="readMessageShow & !isGroup" :class="[item.IsView ? ['fa-check-double-read'] : ['text-secondary']]"></i>
                <span class="blackqute text-dark" v-if="item.DateTimeLastEdit != null">ویرایش شده</span>
              </p>

              <div v-if="item.TblComboGrpId43 === 1804" class="message my_msg gallery">
                <div>
                  <div class="containerImg">
                    <img :src="item.src" class="imageHover img-fluid figure-img img-thumbnail" :id="item.Id" @click="showFullSizeImg(item)" />
                    <div :class="[item.isDownload ? '' : ['overlay']]">
                      <a class="iconImg" title="User Profile" @click="imageDownload(item.Id, url + item.FileSrc)">
                        <i class="fas fa-download" v-if="!item.isDownload"></i>
                        <b-spinner v-if="item.downloading" variant="primary" label="Spinning" class="mx-2"></b-spinner>
                      </a>
                    </div>
                  </div>
                  <!-- کپشن تصویر -->
                  <figcaption class="figure-caption">
                    <!-- {{ item.DecryptMessage }} -->
                    <span>{{ item.DateTimeInsert }} <i class="fas fa-check-double text-se fs-2" v-if="readMessageShow & !isGroup" :class="[item.IsView ? ['fa-check-double-read'] : ['text-secondary']]"></i></span>
                  </figcaption>
                </div>
              </div>

              <div v-else-if="item.TblComboGrpId43 === 1805" class="message my_msg">
                <p>
                  <a @click="fileDownload(item.Id)" class="mr-3" target="_blank" download title="برای دانلود کلیک کنید">
                    <i class="fas fa-download h2 text-secondary hover-info"></i>
                  </a>
                </p>
                <p>
                  {{ item.DecryptMessage }}
                  <br />
                  <span class="text-dark d-inline">{{ item.DateTimeInsert }}</span>
                  <i class="fas fa-check-double text-se fs-2" v-if="readMessageShow & !isGroup" :class="[item.IsView ? ['fa-check-double-read'] : ['text-secondary']]"></i>
                </p>
              </div>
            </div>

            <!-- پیام های طرف مقابل -->
            <div v-else class="message friend_msg justify-content-end">
              <p class="text-right" v-if="item.TblComboGrpId43 == 1802">
                {{ item.DecryptMessage }}
                <span class="text-dark">{{ item.DateTimeInsert }}</span>
                <span class="blackqute text-dark" v-if="isGroup">{{ item.NamFam }}</span>
                <span class="blackqute text-dark" v-if="item.DateTimeLastEdit != null">ویرایش شده</span>
              </p>

              <div v-else-if="item.TblComboGrpId43 === 1804" class="message friend_msg gallery justify-content-end">
                <div>
                  <div class="containerImg">
                    <img :src="item.src" class="imageHover img-fluid figure-img img-thumbnail" :id="item.Id" @click="showFullSizeImg(item)" />
                    <div :class="[item.isDownload ? '' : ['overlay']]">
                      <a class="iconImg" title="User Profile" @click="imageDownload(item.Id, url + item.FileSrc)">
                        <i class="fas fa-download" v-if="!item.isDownload"></i>
                        <b-spinner v-if="item.downloading" variant="primary" label="Spinning" class="mx-2"></b-spinner>
                      </a>
                    </div>
                  </div>
                  <!-- کپشن تصویر -->
                  <figcaption class="figure-caption">
                    <!-- {{ item.DecryptMessage }} -->
                    <span>{{ item.DateTimeInsert }}</span>
                    <br />
                    <span class="blackqute text-dark" v-if="isGroup">{{ item.NamFam }}</span>
                  </figcaption>
                </div>
              </div>

              <div v-else-if="item.TblComboGrpId43 === 1805" class="message friend_msg justify-content-end">
                <p>
                  <a @click="fileDownload(item.Id)" class="mr-3" target="_blank" download title="برای دانلود کلیک کنید">
                    <i class="fas fa-download h2 text-secondary hover-info"></i>
                  </a>
                </p>
                <p>
                  {{ item.DecryptMessage }}
                  <br /><span class="text-dark">{{ item.DateTimeInsert }}</span>
                  <span class="blackqute text-dark" v-if="isGroup">{{ item.NamFam }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="end" style="cursor: pointer" v-if="showTakeMessage">
            <p class="hover-info" @click="takeMessage()">----- بیشتر -----</p>
          </div>
        </div>
        <!-- پایان صفحه پیام ها -->

        <!-- صفحه چت روم ها -->
        <div v-if="isChatRoomsList" class="overflow-auto">
          <div v-for="item in myChatRooms" :key="item.TblChatRoomCrmId" clss="row" @click="goToChatRoom(item, item.ChatRoomName)">
            <div class="float-right text-right p-3 col-12 border-bottom chatRoomItem">
              <!-- <img src="@/assets/SupportProfile.jpg" class="float-right imgChatRoom" /> -->

              <img src="@/assets/icons/user-circle-solid.svg" class="float-right imgChatRoom bg-primary" v-if="(item.Profile == null) & !item.IsGroup" />

              <img src="@/assets/icons/group-svgrepo-com.svg" class="float-right imgChatRoom bg-primary" v-if="(item.Profile == null) & item.IsGroup" />

              <img :src="url + item.Profile" class="float-right imgChatRoom bg-primary" v-if="item.Profile != null" />

              <span class="mr-3 h6">
                {{ item.ChatRoomName }}
              </span>
              <b class="float-left unseenMessage bg-primary" v-if="item.UnseenMessage > 0">{{ item.UnseenMessage }}</b>
            </div>
          </div>
        </div>
        <!-- پایان صفحه چت روم ها -->

        <!-- صفحه ایجاد گروه -->
        <div v-if="createGroupPage" class="card-body bg-light col overflow-auto">
          <h4>ایجاد گروه</h4>
          <hr />
          <form class="col-12">
            <div class="form-group">
              <input type="text" class="form-control" placeholder="نام گروه" v-model="chatRoomNameAddGroup" />
            </div>

            <treeselect name="demo3" :multiple="true" :clearable="false" :searchable="true" :disabled="false" :open-on-click="true" :open-on-focus="false" :clear-on-select="true" :close-on-select="false" :always-open="false" :append-to-body="false" :options="optionsTreeselect" v-model="usersForAddGroup" :normalizer="normalizer" @select="ItemSelected" @deselect="ItemDeselect"> </treeselect>

            <form class="mt-3">
              <div class="form-group">
                <label class="ml-2">پروفایل گروه</label>
                <input type="file" class="form-control" accept="image/*" id="profileGroup" />
              </div>
            </form>
          </form>
          <div class="col-12">
            <div class="btn btn-success col-12 mt-3" @click="submitGroup()">ثبت گروه</div>
          </div>
        </div>
        <!-- پایان صفحه ایجاد پروه -->

        <!-- ورودی های ارسال پیام -->
        <div v-if="!isChatRoomsList & !isEditingMessage & !createGroupPage" class="card-footer">
          <form class="inline">
            <div class="input-icons">
              <i class="icon" v-if="isSendingMesssage">
                <b-spinner variant="primary" label="Spinning"> </b-spinner>
              </i>

              <label style="margin-bottom: 42px" v-if="(showIconSendMs || uploadFileName != '') & !isSendingMesssage">
                <i class="fa-duotone fa-paper-plane-top fa-rotate-180 hover-info mt-1 h5 icon" @click="sendMessage(false)"></i>
              </label>

              <label style="margin-bottom: 32px" v-else-if="!isSendingMesssage">
                <i class="fad fa-paperclip hover-info h5 ml-2 mb-5" title="ارسال عکس"></i>
                <input type="file" class="d-none" id="inputFile" name="image" @change="uploadFile()" :accept="acceptFile" multiple />
              </label>

              <textarea class="input-field form-control d-inline focus-danger" v-model="message" style="resize: none" dir="rtl" id="inputMessage" rows="1" @keyup.enter="sendMessage(true, $event)" placeholder="ارسال پیام Enter"></textarea>

              <!-- <input class="input-field" type="text"> -->
            </div>
          </form>
        </div>
        <!-- پایان ورودی های ارسال پیام -->

        <!-- ورودی های ویرایش پیام -->
        <div v-if="!isChatRoomsList & isEditingMessage & !createGroupPage" class="card-footer">
          <form class="inline">
            <div class="input-icons">
              <i class="icon" v-if="isSendingMesssage">
                <b-spinner variant="primary" label="Spinning"> </b-spinner>
              </i>

              <i @click="isEditingMessage = false" class="fas fa-times hover-danger mt-1 h6 icon" style="margin-left: 2rem"></i>

              <i class="fa-light fa-pen-to-square hover-info mt-1 h6 icon mr-2" @click="editMessage()" v-if="!isSendingMesssage"></i>

              <textarea class="input-field form-control d-inline focus-danger" v-model="messageForEdit" v-if="isEditingMessage" style="resize: none" dir="rtl" id="inputMessage" rows="1"></textarea>
            </div>
          </form>
        </div>
        <!-- پایان ورودی های ویرایش پیام -->
      </div>

      <!-- اطلاعات گروه -->
      <div class="card" dir="rtl" v-if="groupInfoPage">
        <!-- ------------------------------------------------------------------------------------------------------------------------ -->
        <div class="card-header">
          <div clss="row text-right">
            <span class="float-right row">
              <div class="imgBox">
                <img src="@/assets/icons/user-circle-solid.svg" class="float-right imgChatRoom bg-primary" v-if="(profileChatRoom == null) & !isGroup" />
                <div>
                  <img src="@/assets/icons/group-svgrepo-com.svg" class="float-right imgChatRoom bg-primary" v-if="(profileChatRoom == null) & isGroup" />
                  <img :src="url + profileChatRoom" class="float-right imgChatRoom bg-primary" v-if="profileChatRoom != null" />
                </div>
              </div>
              <span class="mr-3 mt-3 h5">
                {{ ChatRoomName }}
              </span>
            </span>
            <i class="fad fa-arrow-left text-secondary float-left mt-3 h4" @click="groupInfoPage = false" title="لیست مخاطبین"></i>
            <i class="fad fa-times-square float-left mt-3 ml-3 h4" @click="messengerShow = false"></i>
          </div>
        </div>
        <!-- ------------------------------------------------------------------------------------------------------------------------ -->
        <div class="card-body bg-light col overflow-auto chatBox d-flex">
          <div>
            <div class="row mr-2">
              <span class="h4 d-block float-right">اعضا:</span>
            </div>
            <div v-if="renderMember">
              <div class="mt-2">
                <span v-for="(item, index) in groupMember" :key="index" class="h6" > {{ item.NamFam }} _ </span>
              </div>
            </div>
            <hr />
            <div class="row mr-2">
              <span class="h4 d-block float-right">اضافه کردن عضو</span>
            </div>
            <div>
              <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="addMember" :rownumintable="3" :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserIdMessenger'" :keyItem="'UserIdMessenger'"> </SearchableCombo>
            </div>
            <hr />
            <div class="mt-2">
              <button class="btn btn-danger" @click="leaveGroup()">ترک گروه</button>
            </div>
          </div>
        </div>
        <!-- ------------------------------------------------------------------------------------------------------------------------ -->
      </div>
      <!-- پایان اطلاعات گروه -->
    </div>
  </div>
</template>

<script>
import SearchableCombo from "@/components/Combo/SearchableCombo.vue";
import JSZip from "jszip";
import Treeselect from "@riophae/vue-treeselect";

export default {
  components: { SearchableCombo, Treeselect },
  data() {
    return {
      message: "",
      rows: 1,
      numKeys: 0,
      showIconSendMs: false,
      isChatRoomsList: true,
      newLine: "",
      acceptFile: [".jpg", ".gif", ".jpeg", ".png", ".pdf", ".bmp", ".txt", ".zip", ".rar"],
      userId: this.$session.get("UserInfo").tblUserId,
      tblUserGrpIdInsert: this.$session.get("UserInfo").tblUserGrpId,
      myChatRooms: [],
      chatMessage: [],
      ChatRoomName: "",
      uploadFileName: "",
      messengerConnection: null,
      chatRoomId: null,
      isImage: null,
      base64: null,
      fileFormat: "",
      isSendingMesssage: false,
      messengerShow: false,
      fileSize: 0,
      url: this.$cookies.get("URL"),
      newChatRoom: 0,
      readMessageShow: true,
      page: 1,
      showTakeMessage: true,
      isEditingMessage: false,
      idMessageForEdit: null,
      messageForEdit: "",
      textareaHeight: 3,
      createGroupPage: false,
      usersForAddGroup: [],
      optionsTreeselect: [],
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
      chatRoomNameAddGroup: "",
      profileChatRoom: null,
      isGroup: false,
      messengerHubConnected: false,
      manualStopHub: false,
      tryConnect: null,
      firstTimeConnectMessenger: false,
      groupInfoPage: false,
      totalUnseenMessage: 0,
      groupMember: [],
      renderMember: true,
    };
  },

  updated() {
    // اضافه کردن خط جدید به تکست آریا
    if ((this.chatRoomId != null) & (this.chatRoomId > 0) & !this.isChatRoomsList & !this.createGroupPage) {
      var inputMessage = document.getElementById("inputMessage");
      if (inputMessage != undefined) {
        let valueInput = inputMessage.value;
        if (valueInput.length == 0) {
          this.showIconSendMs = false;
          //   this.textareaHeight = 3;
          //   inputMessage.style.height = "3rem";
          //   inputMessage.style.overflowY = "hidden";
        }
        if (valueInput.length > 0) {
          this.showIconSendMs = true;
        }
        // if (valueInput.length > 40 * this.rows) {
        //   inputMessage.style.overflowY = "visible";
        //   this.textareaHeight += 1;
        //   inputMessage.style.height = this.textareaHeight + "rem";
        //   this.rows++;
        // }
        // if (this.message.length > 40) {
        //   if (this.message.length < 40 * this.rows) {
        //     this.textareaHeight -= 1;
        //     inputMessage.style.height = this.textareaHeight + "rem";
        //     this.rows--;
        //   }
        // }
      }
    }
    // پایان اضافه کردن خط جدید به تکست آریا
  },
  created() {
    // this.getChatRooms()
    this.MessengerHub();
  },
  methods: {
    addMember(data) {
      if (data.id != null) {
        let DataaxiosDepUser = {
          Action: "Messenger/AddMember",
          Method: "POST",
          ArryfildValue: {
            TblChatRoomCrmId: this.chatRoomId,
            TblUserId: data.id,
            TblUserGrpIdInsert: this.tblUserGrpIdInsert,
          },
        };
        this.$PostData(DataaxiosDepUser).then((res) => {
          if (res.Status == "Ok") {            
            this.groupMember.push({
              NamFam : data.name
            });
            this.$toasted.success(res.Meesage, {
              action: {
                text: "بستن",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            });
          } else {
            this.$toasted.error(res.Meesage, {
              action: {
                text: "بستن",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            });
          }
        });
      }
    },
    leaveGroup() {
      let DataaxiosDepUser = {
        Action: "Messenger/LeftGroup",
        Method: "POST",
        ArryfildValue: {
          ChatRoomId: this.chatRoomId,
          TblUserId: this.userId,
        },
      };
      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          if (res.Status == "Ok") {
            this.$toasted.success("با موفقیت از گروه خارج شدید", {
              action: {
                text: "بستن",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            });
            this.groupInfoPage = false;
            this.getChatRooms();
            this.messengerConnection.invoke("LeftGroup", String(this.chatRoomId));
          } else {
            this.$toasted.error("اشکال در اطلاعات", {
              action: {
                text: "بستن",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            });
          }
        })
        .catch((err) => {
          console.error(err);
          this.$toasted.error("خطایی رخ داد", {
            action: {
              text: "بستن",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          });
        });
    },
    shake() {
      this.messengerConnection.invoke("ShakePage", String(this.chatRoomId)).then(() => {});
    },
    tryConnectInterval() {
      if (!this.messengerHubConnected) {
        if (!this.manualStopHub) {
          this.MessengerHub().then(() => {
            this.messengerHubConnected = true;
            clearInterval(this.tryConnect);
          });
        }
      }
    },
    changeColorMessengerRed() {
      let iconMessenger = document.getElementById("messengerShow");
      iconMessenger.style.color = "red";
    },
    changeColorMessengerDefault() {
      let iconMessenger = document.getElementById("messengerShow");
      iconMessenger.style.color = "#467fe2";
    },
    async MessengerHub() {
      this.$MessengerHub()
        .then((res) => {
          this.messengerConnection = res;
          res.invoke("UserJoinGroup", String(this.userId));
          this.messengerHubConnected = true;
          this.firstTimeConnectMessenger = true;
          // تلاش برای اتصال هاب در صورت قطع شدن
          // this.messengerConnection.onclose(() => {
          //   if (!this.manualStopHub) {
          //     this.messengerHubConnected = false;
          //     this.tryConnect = setInterval(this.tryConnectInterval, 1100);
          //   }
          // });

          res.on("getNewMessage", (Id, Message, DateTimeInsert, TblChatRoomId, TblComboGrpId43, SenderTblUserId, senderName, fileSrc) => {
            console.log("getNewMessage2");
            if (this.chatRoomId == TblChatRoomId) {
              let newMessage = {
                Id: Id,
                TblChatRoomId: TblChatRoomId,
                SenderTblUserId: SenderTblUserId,
                TblComboGrpId43: TblComboGrpId43,
                DecryptMessage: Message,
                FileSrc: fileSrc,
                NamFam: senderName,
                DateTimeInsert: DateTimeInsert,
              };
              if (TblComboGrpId43 == 1804) {
                newMessage.isDownload = false;
                newMessage.downloading = false;
                newMessage.src = "";
              }
              this.chatMessage.unshift(newMessage);

              if (SenderTblUserId != this.userId) {
                this.messengerConnection.invoke("ViewNewMessage", String(Id), String(SenderTblUserId));
              }
              setTimeout(() => {
                this.cursorDefaultBtnDrop();
              }, 200);
            } else {
              var chatRoom = this.myChatRooms.find((x) => x.TblChatRoomCrmId == TblChatRoomId);
              chatRoom.UnseenMessage += 1;

              var old_index = this.myChatRooms.indexOf(chatRoom);
              this.array_move(this.myChatRooms, old_index, 0);
              if (SenderTblUserId != this.userId) {
                var vueThis = this;
                const notification = {
                  title: senderName,
                  options: {
                    body: "یک پیام جدید",
                    icon: "https://bnpco.ir/favicon.ico",
                  },
                  events: {
                    onclick: function () {
                      vueThis.messengerShow = true;
                    },
                  },
                };
                this.$notification.show(notification.title, notification.options, notification.events);
                if (!this.messengerShow) {
                  this.totalUnseenMessage += 1;
                }
              }
            }
          });

          res.on("haveNewChatRoom", (chatRoomId, userIdInsert) => {
            res
              .invoke("UserJoinNewChatRoom", chatRoomId)
              .then(() => {
                if (userIdInsert == this.userId) {
                  this.newChatRoom = 0;
                }
                this.getChatRooms(true, chatRoomId, userIdInsert);
              })
              .catch((err) => {
                console.error("CATCH", err);
                if (userIdInsert == this.userId) {
                  this.$mySweetDefaultTost("عملیات ناموفق", "ارسال پیام با خطا مواجه شد", "error", 2000);
                  this.isSendingMesssage = false;
                }
              });
          });

          res.on("ViewNewMessage", (MessageId) => {
            var message = this.chatMessage.find((el) => el.Id == MessageId);
            message.IsView = true;
            this.readMessageShow = false;
            this.$nextTick(() => {
              this.readMessageShow = true;
            });
          });

          res.on("ViewMessage", (ChatRoomId) => {
            if (this.chatRoomId == ChatRoomId) {
              let messages = this.chatMessage.slice(0, 15);
              messages.forEach((el) => {
                el.IsView = true;
              });
              this.readMessageShow = false;
              this.$nextTick(() => {
                this.readMessageShow = true;
              });
            }
          });

          res.on("editMessage", (messageId, message) => {
            let mess = this.chatMessage.find((el) => el.Id == messageId);
            if (mess != undefined) {
              mess.DecryptMessage = message;
              mess.DateTimeLastEdit = "00:00";
            }
          });

          res.on("removeMessage", (messageId) => {
            let Mess = this.chatMessage.find((el) => el.Id == messageId);
            if (Mess != undefined) {
              let indexMess = this.chatMessage.indexOf(Mess);
              this.chatMessage.splice(indexMess, 1);
            }
          });

          res.on("shakePage", () => {
            let myDiv = document.getElementById("main");
            if (myDiv != null) {
              myDiv.classList.add("shaking");
              setTimeout(() => {
                myDiv.classList.remove("shaking");
              }, 2000);
            } else {
              myDiv = document.getElementById("messengerShow");
              myDiv.classList.add("shaking");
              setTimeout(() => {
                myDiv.classList.remove("shaking");
              }, 2000);
            }
          });
        })
        .catch((error) => {
          this.$mySweetDefaultTost("عملیات ناموفق", "خطا در ایجاد اتصال مسنجر", "error", 2000);
          console.error("CATCH", error);
        })
        // .finally(() => {
        //   if (this.messengerConnection._connectionStarted === false || this.messengerConnection == null) {
        //     setTimeout(() => {
        //       this.MessengerHub();
        //     }, 1000);
        //   }
        // });
    },
    submitGroup() {
      let profileGroup = document.getElementById("profileGroup").files[0];
      if (profileGroup != undefined) {
        if (Math.round(profileGroup.size / 1000 > 1010)) {
          this.$mySweetDefaultTost("", "حجم عکس پروفایل گروه باید کمتر از 1 مگ باشد", "info", 2000);
          return;
        }
      }
      var formData = new FormData();
      formData.append("TblUserGrpIdInsert", this.tblUserGrpIdInsert);
      formData.append("ChatRoomName", this.chatRoomNameAddGroup);
      formData.append("IsGroup", true);
      formData.append("profileGroup", profileGroup);

      this.usersForAddGroup.forEach((element) => {
        formData.append("UserIds", element);
      });

      let DataaxiosDepUser = {
        Action: "Messenger/CreateChatRoom",
        Method: "POST",
        ArryfildValue: formData,
      };

      this.$PostFormData(DataaxiosDepUser)
        .then((response) => {
          if (response.Status == "Not Ok") {
            this.$mySweetDefaultTost("عملیات ناموفق", response.Message, "error", 2000);
          } else if (response.Status == "Ok") {
            this.$mySweetDefaultTost("عملیات موفق", response.Message, "success", 2000);
            this.usersForAddGroup = [];
            this.chatRoomNameAddGroup = "";
            this.messengerConnection.invoke("UserJoinNewChatRoom", String(response.ChatRoom.TblChatRoomCrmId)).then(() => {
              this.getChatRooms();
            });
          } else {
            this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
          }
        })
        .catch((err) => {
          this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
          console.error(err);
        });
    },
    createGroup() {
      this.GetDataUser();
      this.createGroupPage = true;
      this.isChatRoomsList = false;
    },
    ItemSelected(node) {
      this.usersForAddGroup.push(node.id);
    },
    ItemDeselect(node) {
      for (let index = 0; index < this.usersForAddGroup.length; index++) {
        if (this.usersForAddGroup[index] == node.id) {
          this.usersForAddGroup.splice(index, 1);
        }
      }
    },
    GetDataUser() {
      let DataAxios_Data = {
        ArryfildValue: {},
        Method: "post",
        Action: "TblCrmCombo/GetUserDatails",
      };
      this.$PostData(DataAxios_Data)
        .then((data) => {
          this.optionsTreeselect = data;
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        });
    },
    validationSendMessage(withEnter) {
      if (this.message != null) {
        var validMessage = "";
        if (withEnter) {
          validMessage = this.message.replaceAll("\n", "");
        }

        if (validMessage != null) {
          validMessage = this.message.replace(/\s/g, "");
        }
        if (this.message == null || (validMessage == "" && this.base64 == null)) {
          this.$mySweetDefaultTost("", "مقادیر را برای ارسال پیام وارد نمایید", "info", 1200);
          this.cancelUpload();
          this.message = "";
          return false;
        } else {
          this.message = this.message.replace(/\n$/, "");
          return true;
        }
      } else {
        this.$mySweetDefaultTost("", "مقادیر را برای ارسال پیام وارد نمایید", "info", 1200);
        this.cancelUpload();
      }
    },
    editMessage() {
      this.isSendingMesssage = true;
      if (this.messageForEdit.length > 0) {
        this.messengerConnection
          .invoke("EditMessage", String(this.idMessageForEdit), String(this.messageForEdit), String(this.chatRoomId), String(this.userId))
          .then((res1) => {
            this.messageForEdit = "";
            this.idMessageForEdit = null;
            this.isEditingMessage = false;
            let mess = this.chatMessage.find((el) => el.Id == this.idMessageForEdit);
            if (mess != undefined) {
              mess.DecryptMessage = message;
            }
          })
          .catch((err) => {
            console.error(err);
            this.$toasted.error("اشکال در ویرایش پیام", {
              action: {
                text: "بستن",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            });
          })
          .finally(() => {
            this.isSendingMesssage = false;
          });
      } else {
        this.$toasted.error("لطفا متن پیام ویرایش شده را وارد نمایید", {
          action: {
            text: "بستن",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        });
        this.isSendingMesssage = false;
      }
    },
    edit(item) {
      this.isEditingMessage = true;
      this.messageForEdit = item.DecryptMessage;
      this.idMessageForEdit = item.Id;
    },
    remove(item) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success mx-1",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "اطمینان دارید؟",
          text: "از حذف پیام " + "[" + item.DecryptMessage.slice(0, 10) + "..." + "]" + "؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "بله، حذف شود",
          cancelButtonText: "لغو",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.messengerConnection
              .invoke("RemoveMessage", String(item.Id), String(this.userId))
              .then(() => {
                this.$toasted.success("حذف با موفقیت صورت گرفت", {
                  action: {
                    text: "بستن",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    },
                  },
                });
                let Mess = this.chatMessage.find((el) => el.Id == item.Id);
                if (Mess != undefined) {
                  let indexMess = this.chatMessage.indexOf(Mess);
                  this.chatMessage.splice(indexMess, 1);
                }
              })
              .catch((err) => {
                console.error(err);
                this.$toasted.error("اشکال در حذف پیام", {
                  action: {
                    text: "بستن",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    },
                  },
                });
              });
          }
        });
    },
    showDropDown(messageId) {
      let dropDown = document.getElementById("drop-" + messageId);
      dropDown.click();
    },
    takeMessage() {
      this.page = this.page + 1;
      let DataaxiosDepUser = {
        Action: "Messenger/GetChatMessage",
        Method: "post",
        ArryfildValue: {
          ChatRoomId: this.chatRoomId,
          TblUserId: this.userId,
          Page: this.page,
        },
      };
      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          let haveUnreadMessage = false;
          let user2Id = null;
          res.forEach((element) => {
            if (element.TblComboGrpId43 == 1804) {
              element.isDownload = false;
              element.downloading = false;
              element.src = "";
            }
            if (!haveUnreadMessage) {
              if ((element.IsView == false) & (element.SenderTblUserId != this.userId)) {
                haveUnreadMessage = true;
                user2Id = element.SenderTblUserId;
              }
            }
          });
          res.forEach((el) => {
            this.chatMessage.push(el);
          });
          // if (!isNewChatRoom) {
          //     this.isChatRoomsList = false
          // }
          if (haveUnreadMessage) {
            this.messengerConnection.invoke("ViewMessage", String(user2Id), String(chatRoomId));
          }
          if (res.length < 10) {
            this.showTakeMessage = false;
          } else {
            this.showTakeMessage = true;
          }
        })
        .catch((error) => {
          this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
          console.error("CATCH", error);
        });
    },
    cancelUpload() {
      this.base64 = null;
      this.uploadFileName = "";
      this.fileSize = 0;
      var input = document.getElementById("inputFile");
      if (input != null) {
        input.value = "";
      }
      this.fileFormat = "";
      this.isImage = null;
      let inputMessage = document.getElementById("inputMessage");
      inputMessage.disabled = false;
      inputMessage.placeholder = "ارسال پیام Enter";
    },

    async uploadFile() {
      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      var input = document.getElementById("inputFile");
      let inputMessage = document.getElementById("inputMessage");
      if (input.files.length <= 5) {
        if (input.files.length > 1) {
          let filedata = null;
          let zip = new JSZip();
          this.fileSize = 0;
          this.uploadFileName = "";
          for (let index = 0; index < input.files.length; index++) {
            var Checktypes = "." + input.files[index].name.split(".")[1].toLowerCase();
            if (this.acceptFile.includes(Checktypes)) {
              this.fileSize += input.files[index].size;
              this.uploadFileName += input.files[index].name + " , ";
              const element = input.files[index];
              let filename = input.files[index].name;
              var folderName = this.$store.state.JalaliDate;
              folderName = folderName.replaceAll("/", "_");
              zip.file(folderName + "/" + filename, element);
            } else {
              let Validformats = "فرمت های معتبر" + "\n";
              this.acceptFile.forEach((element) => {
                element = element.split(".");
                Validformats += element[1] + ", ";
              });
              this.$mySweetDefaultTost("فرمت فایل نامعتبر", Validformats, "info", 6000);
              this.cancelUpload();
              return;
            }
          }
          this.fileSize = Math.round(this.fileSize / 1000);
          if (this.fileSize < 10010) {
            await zip
              .generateAsync({ type: "base64" })
              .then(function (Convertbase64) {
                filedata = "data:application/zip;base64," + Convertbase64;
              })
              .finally(() => {
                this.base64 = filedata;
                this.base64 = this.base64.split(",")[1];
                this.isImage = false;
                this.fileFormat = "zip";
                inputMessage.disabled = true;
                inputMessage.placeholder = this.uploadFileName;
              });
          } else {
            this.$mySweetDefaultTost("عملیات ناموفق", "مجموع حجم فایل ها باید کمتر از 10 مگابایت باشد", "info", 3000);
            this.cancelUpload();
          }
        } else {
          var Checktype = "." + input.files[0].name.split(".")[1].toLowerCase();
          if (this.acceptFile.includes(Checktype)) {
            var image = input.files[0];
            var imageType = image.type.split("/")[0];
            var imageName = image.name.split(".");
            var imageNameLength = imageName.length;
            this.fileFormat = imageName[imageNameLength - 1];

            this.fileSize = Math.round(image.size / 1000);

            if (this.fileSize < 10010) {
              this.uploadFileName = image.name;
              this.base64 = await toBase64(image);
              this.base64 = this.base64.split(",")[1];

              inputMessage.disabled = true;
              inputMessage.placeholder = this.uploadFileName;
              if (imageType == "image") {
                this.isImage = true;
              } else {
                this.isImage = false;
              }
            } else {
              this.$mySweetDefaultTost("عملیات ناموفق", "حجم فایل باید کمتر از 10 مگابایت باشد", "info", 2500);
              this.cancelUpload();
            }
          } else {
            let Validformats = "فرمت های معتبر:" + "\n";
            this.acceptFile.forEach((element) => {
              element = element.split(".");
              Validformats += element[1] + ", ";
            });
            this.$mySweetDefaultTost("فرمت فایل نامعتبر", Validformats, "info", 6000);
            this.cancelUpload();
          }
        }
      } else {
        this.$mySweetDefaultTost("عملیات ناموفق", "حداکثر تعداد فایل انتخابی 5 عدد است", "info", 2500);
      }
    },
    imageDownload(messageId, src) {
      let dataaxios = {
        Action: "Messenger/DownloadFiles/" + messageId,
        Method: "Get",
      }
      let img = document.getElementById(messageId)
      let record = this.chatMessage.find((x) => x.Id == messageId)
      record.downloading = true
      record.isDownload = true;

      this.$PostData(dataaxios).then((response) => {
        if(response.isSuccess){
          record.src = 'data:image/' + response.data.extenstion + ';base64, ' + response.data.file
          img.onload = () => (record.downloading = false)
        }else{
          this.$mySweetDefaultTost("عملیات ناموفق", response.message, "error", 2000);
          record.downloading = false
        }
      }).catch((error) => {
        console.error("CATCH", error);
      })

      // let img = document.getElementById(messageId);
      // let record = this.chatMessage.find((x) => x.Id == messageId);
      // record.isDownload = true;
      // record.downloading = true;
      // record.src = src;
      // img.onload = () => (record.downloading = false);

    },
    showFullSizeImg(item, isProfile) {
      if (item.isDownload) {
        let fullPage = document.getElementById("fullpage");
        let img = document.getElementById(item.Id);

        fullPage.style.backgroundImage =  "url('" + img.src + "')"
        fullPage.style.display = "block";
      }
      if (isProfile) {
        let fullPage = document.getElementById("fullpage");
        let img = document.getElementById(item.Id);

        fullPage.style.backgroundImage = "url('" + img.src + "')"
        fullPage.style.display = "block";
      }
    },
    sendMessage(withEnter, ev) {
      if (ev != undefined) {
        if (ev.shiftKey) {
          var inputMessage = document.getElementById("inputMessage");
          this.textareaHeight += 1;
          inputMessage.style.height = this.textareaHeight + "rem";
          inputMessage.style.overflowY = "visible";
        } else {
          if (this.validationSendMessage(withEnter)) {
            this.invokeMessage();
          }
        }
      } else {
        if (this.validationSendMessage(withEnter)) {
          this.invokeMessage();
        }
      }
    },

    invokeMessage() {
      this.isSendingMesssage = true;
      if (this.message.length < 2000) {
        this.messengerConnection
          .invoke("SendMessage", String(this.chatRoomId), this.message, String(this.userId), String(this.tblUserGrpIdInsert), this.base64, this.fileFormat, String(this.isImage))
          .then(() => {
            this.cancelUpload();
            this.message = "";
          })
          .catch((err) => {
            console.error("CATCH", err);
            this.$mySweetDefaultTost("عملیات ناموفق", "ارسال پیام با خطا مواجه شد", "error", 2000);
          })
          .finally(() => {
            this.isSendingMesssage = false;
          });
      } else {
        this.$mySweetDefaultTost("", "حداکثر طول پیام 2000 کاراکتر است", "error", 2000);
        this.isSendingMesssage = false;
      }
    },

    goToChatRoom(item, chatRoomName, isNewChatRoom) {
      let DataaxiosDepUser = {
        Action: "Messenger/GetChatMessage",
        Method: "post",
        ArryfildValue: {
          ChatRoomId: item.TblChatRoomCrmId,
          TblUserId: this.userId,
        },
      };
      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          let haveUnreadMessage = false;
          let user2Id = null;
          res.forEach((element) => {
            if (element.TblComboGrpId43 == 1804) {
              element.isDownload = false;
              element.downloading = false;
              element.src = "";
            }
            if (!haveUnreadMessage) {
              if ((element.IsView == false) & (element.SenderTblUserId != this.userId)) {
                haveUnreadMessage = true;
                user2Id = element.SenderTblUserId;
              }
            }
          });
          this.chatMessage = res;

          if (!isNewChatRoom) {
            this.isChatRoomsList = false;
          }
          this.ChatRoomName = chatRoomName;
          this.chatRoomId = item.TblChatRoomCrmId;
          this.profileChatRoom = item.Profile;
          this.isGroup = item.IsGroup;

          if (haveUnreadMessage) {
            this.messengerConnection.invoke("ViewMessage", String(user2Id), String(item.TblChatRoomCrmId));
          }
          if (this.chatMessage.length == 10) {
            this.showTakeMessage = true;
          } else {
            this.showTakeMessage = false;
          }
        })
        .catch((error) => {
          this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
          console.error("CATCH", error);
        })
        .finally(() => {
          this.cursorDefaultBtnDrop();
        });
    },
    getChatRooms(isNewChatRoom, chatRoomId, userIdInsert) {
      let DataaxiosDepUser = {
        Action: "Messenger/GetMyChatRooms",
        Method: "Get",
        ArryfildValue: {
          Id: this.userId,
        },
      };
      this.$GetData_Header(DataaxiosDepUser)
        .then((res) => {
          this.myChatRooms = res;
          if (!isNewChatRoom) {
            this.isChatRoomsList = true;
            this.chatRoomId = null;
            this.page = 1;
            this.createGroupPage = false;
          }
        })
        .catch((error) => {
          this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
          console.error("CATCH", error);
        })
        .finally(() => {
          this.myChatRooms.forEach((el) => {
            this.totalUnseenMessage += el.UnseenMessage;
          });
        });
    },

    fileDownload(messageId){
      let dataaxios = {
        Action: "Messenger/DownloadFiles/" + messageId,
        Method: "Get",
      }
      this.$PostData(dataaxios).then((response) => {
        if(response.isSuccess){
          var fileLink = document.createElement('a')
          fileLink.href = 'data:application/' + response.data.extenstion + ';base64,' + response.data.file
          fileLink.setAttribute('download', response.data.fileName)
          document.body.appendChild(fileLink)
          fileLink.click()
        }else{
          this.$mySweetDefaultTost("عملیات ناموفق", response.message, "error", 2000);
        }
      }).catch((error) => {
        console.error("CATCH", error);
      })
    },
    GetResulUserId(data) {
      if (data.id != null) {
        var formData = new FormData();
        formData.append("TblUserGrpIdInsert", this.tblUserGrpIdInsert);
        formData.append("IsGroup", false);
        formData.append("UserIds", this.userId);
        formData.append("UserIds", data.id);

        let DataaxiosDepUser = {
          Action: "Messenger/CreateChatRoom",
          Method: "POST",
          ArryfildValue: formData,
        };

        this.$PostFormData(DataaxiosDepUser)
          .then((response) => {
            if (response.Status != "Not Ok") {
              if (response.Status == "isExsit") {
                this.goToChatRoom(response.ChatRoom, data.name);
              }
              if (response.Status == "Ok") {
                this.messengerConnection
                  .invoke("CreateChatRoom", String(response.ChatRoom.TblChatRoomCrmId), String(this.userId))
                  .then(() => {
                    // this.newChatRoom = 0
                    // this.newChatRoom = response.ChatRoomId

                    this.goToChatRoom(response.ChatRoom, data.name);
                  })
                  .catch((err) => {
                    console.error("CATCH", err);
                  });
              }
            } else {
              this.$mySweetDefaultTost("عملیات ناموفق", response.Message, "error", 2000);
            }
          })
          .catch((error) => {
            this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
            console.error("CATCH", error);
          });
      }
    },

    array_move(arr, old_index, new_index) {
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; // for testing
    },

    getGroupInfo() {
      this.groupInfoPage = true;

      let DataaxiosDepUser = {
        Action: "Messenger/GetGroupInfo",
        Method: "POST",
        ArryfildValue: {
          ChatRoomId: this.chatRoomId,
        },
      };
      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          this.groupMember = res;
        })
        .catch((err) => {
          console.error("CATCH", err);
          this.$mySweetDefaultTost("عملیات ناموفق", "", "error", 2000);
        });
    },

    cursorDefaultBtnDrop() {
      let btnDrop = document.querySelectorAll(".btn-drop");
      btnDrop.forEach((el) => {
        el.style.cursor = "default";
      });
    },

    Showmessenger() {
      this.messengerShow = true;
      this.totalUnseenMessage = 0;
      let iconMessenger = document.getElementById("messengerShow");
      iconMessenger.style.color = "";
    },
  },

  mounted() {
    this.getChatRooms();

    document.addEventListener("click", (event) => {
      if (this.messengerShow) {
        let idMain = false;
        if (event != undefined) {
          if (event.path != undefined) {
            event.path.forEach((el) => {
              let swal = document.getElementsByClassName("swal2-container");
              let tost = document.getElementsByClassName("toasted");
              if (el.id == "main" || swal.length > 0 || tost.length > 0) {
                idMain = true;
              }
            });
            if (idMain == false) {
              this.messengerShow = false;
            }
          }
        }
      }
    });
  },

  beforeDestroy() {
    // this.messengerConnection.invoke('UserRemoveGroup', String(this.userId))
    this.manualStopHub = true;
    this.messengerConnection.stop().then(() => {
      this.manualStopHub = true;
      clearInterval(this.tryConnect);
    });
  },
};
</script>

<style scoped>
i {
  color: var(--logo-color);
}

.sc {
  overflow-y: scroll;
}

.message {
  position: relative;
  display: flex;
  width: 100%;
  margin: 5px 0;
}

.card-body {
  background: var(--sidebar-bg-color) !important;
}

.card {
  background: var(--sidebar-bg-color) !important;
  min-height: 600px;
  max-height: 600px;
}

.message p {
  color: black !important;
  position: relative;
  right: 0;
  text-align: right;
  max-width: 65%;
  padding: 12px;
  background: #dcf8c8;
  border-radius: 10px;
  font-size: 0.9em;
}

p {
  color: var(--sidebar-color-item) !important;
}

.message p::before {
  /* content: ""; */
  position: absolute;
  top: 0;
  right: -12px;
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #dcf8c6 0%, #dcf8c6 50%, transparent 50%, transparent);
}

.message p span {
  display: block;
  margin-top: 5px;
  font-size: 0.85em;
  opacity: 0.5;
}

/* .my_msg {
    justify-content: flex-start;
} */

.message.friend_msg p::before {
  /* content: ""; */
  position: absolute;
  top: 0;
  left: -12px;
  width: 20px;
  height: 20px;
  background: linear-gradient(225deg, #fff 0%, #fff 50%, transparent 50%, transparent);
}

/* .my_msg {
    justify-content: flex-end;
} */

/* .friend_msg {
    justify-content: flex-start;
} */

.friend_msg p {
  background: #e5fafa;
  text-align: left;
}

.inputMessage {
  resize: none;
}

.imgBox {
  position: relative;
  min-width: 45px;
  height: 45px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 10px;
}

.cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

i {
  cursor: pointer;
}

.chatRoomItem {
  cursor: pointer;
  border-bottom: 1px var(--sidebar-color-item) solid;
}

.chatRoomItem:hover {
  background-color: var(--sidebar-item-hover-bg-color);
}

.unseenMessage {
  background: #06d755;
  color: #fff;
  min-width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
}

.imgChatRoom {
  width: 45px;
  height: 45px;
  border-radius: 50%;
}

.inline {
  /* max-width: 400px; */
  margin: auto;
  direction: ltr;
}

.input-icons i {
  position: absolute;
}

.input-icons {
  /* width: 100%; */
  /* margin-bottom: 10px; */
}

.icon {
  padding: 10px;
  /* min-width: 50px; */
}

.input-field {
  width: 100%;
  padding: 10px;
  text-align: right;
  margin-bottom: 3px;
}

.imageName {
  border-radius: 5px;
  background: rgb(209, 208, 212);
  width: 100%;
}

.focus-danger:focus {
  border: var(--logo-color) 1px solid !important;
}

.messenger {
  font-size: 3rem;
  color: var(--sidebar-color-item);
}

hr {
  color: var(--sidebar-color-item);
}

.messenger:hover {
  color: var(--logo-color);
  font-size: 3.5rem;
  transition: all 0.4s ease !important;
}

.gallery img {
  /* min-width: 100%; */
  min-width: 120px;
  max-width: 120px;
  min-height: 120px;
  max-height: 120px;
  background-color: #eef8ff;
}

.imageHover {
  display: block;
}

.iconImg {
  color: rgb(209, 208, 212);
  font-size: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.iconImg i:hover {
  color: #1b5172;
  transition: 0.3s;
}

.iconImg span {
  color: #1d8fda !important;
  font-size: 24px;
}

.iconImg i {
  color: #0b213236;
}

.containerImg {
  position: relative;
}

.containerImg .overlay {
  opacity: 1;
}

#fullpage {
  display: none;
  position: absolute;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-size: contain;
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-color: black;
}

.widget-icon {
  transition: all 0.4s ease !important;
  width: 100px;
}

.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-duration: 0.4s;
  animation-duration: 0.4s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.fa-check-double-read {
  color: blue;
}

.fa-check-double {
  cursor: default;
}

.cusrser-default {
  cursor: default !important;
}

#inputMessage {
  height: 8rem;
  max-height: 6.1rem !important;
}

#main {
  /* resize: horizontal; */
  /* overflow: auto; */
}

#main::-webkit-resizer {
  background-color: var(--logo-color);
}

.shaking {
  animation: shake 0.3s;
  animation-iteration-count: infinite;
}
@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

.overlay-messenger {
  position: absolute; /*Sit on top of the page content*/
}

#messengerShow {
  position: absolute;
}
</style>
